import type { Network } from "../types";

export const viber: Network = {
  name: "Viber",
  shareUrl: "viber://forward?text=[u]",
  args: {
    title: "%20[t]",
  },
  icon: "/media/images/facebook-social-auth.svg",
  color: "#7360f2",
};
